import { SelectOptionType } from 'utils/react-table';

type ContactCategoryDto = {
    id?: number | null;
    name: string;
    isFilterable: boolean;
};

export const mapContactCategoryToSelectOption = (
    contactCategories: Array<ContactCategoryDto>,
): Array<SelectOptionType> => {
    return contactCategories.map((category) => ({ value: category.id ?? 0, label: category.name }));
};

export default ContactCategoryDto;
